/**
 * useClient rejects with `{ status, message }`, where `message` is the response
 * body as text (honoServer.onError answers a CustomError with `ctx.text`). This
 * narrows that `unknown` without trusting its shape.
 */
export type ApiFailure = { status: number | null; message: string | null };

export const readApiError = (error: unknown): ApiFailure => {
  if (typeof error !== 'object' || error === null) return { status: null, message: null };
  const status = 'status' in error && typeof error.status === 'number' ? error.status : null;
  const message = 'message' in error && typeof error.message === 'string' && error.message ? error.message : null;
  return { status, message };
};
